/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ImprintInputs */

const en_imprint = /** @type {(inputs: ImprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprint`)
};

const de_imprint = /** @type {(inputs: ImprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

/**
* | output |
* | --- |
* | "Imprint" |
*
* @param {ImprintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const imprint = /** @type {((inputs?: ImprintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ImprintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_imprint(inputs)
	return en_imprint(inputs)
});